export default "__VITE_ASSET__JMkBlMuU__";